import { whiteListPermission } from './apis';
import { useState, useEffect } from 'react';
import { message } from '@drip/drip-design';

//1：所有者，2：管理者，3：协作者，4：申请者
export function useGetAuthRole(query) {
  const { businessId, businessType, planCode } = query;
  const [data, setData] = useState('');

  useEffect(() => {
    if (businessId === 'none') return;
    whiteListPermission({ businessId, businessType, planCode })
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg || '白名单管理权限请求失败';
        setData(data.identityType);
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [businessId, businessType, planCode]);

  return {
    showApplyBtn: [3, 4].includes(Number(data)),
    showMangeBtn: [1, 2].includes(Number(data)),
    isOwner: data == 1,
    isManage: data == 2,
    isPartner: data == 3,
    isApplicant: data == 4,
  };
}
